function apiBase(): string {
  const raw = import.meta.env.VITE_API_BASE_URL;
  if (typeof raw === 'string' && raw.length > 0) return raw.replace(/\/$/, '');
  return '';
}

export type ComCatBrandItem = {
  brand: string;
  variants: string[];
};

/**
 * Brands with nested variants from `ComCatBrand` (ordered by weight).
 */
export async function fetchComCatBrandCatalog(): Promise<ComCatBrandItem[]> {
  const res = await fetch(`${apiBase()}/api/v1/com-cat-brands`);
  if (!res.ok) {
    throw new Error('Unable to load brand list.');
  }

  const data = (await res.json()) as { brands?: Array<{ brand?: unknown; variants?: unknown }> };
  const raw = Array.isArray(data.brands) ? data.brands : [];

  return raw
    .map((item) => {
      const brand = typeof item.brand === 'string' ? item.brand.trim() : '';
      const variants = Array.isArray(item.variants)
        ? item.variants.filter((v): v is string => typeof v === 'string' && v.trim().length > 0)
        : [];
      return { brand, variants };
    })
    .filter((item) => item.brand.length > 0 && item.variants.length > 0);
}

/**
 * Distinct `ComCatBrand.variant` values for the given brand (ordered by weight).
 */
export async function fetchComCatVariantsForBrand(brand: string): Promise<string[]> {
  const trimmed = brand.trim();
  if (!trimmed) {
    return [];
  }

  const params = new URLSearchParams({ brand: trimmed });
  const res = await fetch(`${apiBase()}/api/v1/com-cat-brands/variants?${params.toString()}`);
  const data = (await res.json()) as { variants?: unknown };

  if (!res.ok || !Array.isArray(data.variants)) {
    return [];
  }

  return data.variants.filter((v): v is string => typeof v === 'string' && v.length > 0);
}
